import { colors } from '@khaddi/ui';
import { createElement, useMemo } from 'react';
import { View } from 'react-native';

const SIZE = 21;
const FINDERS: [number, number][] = [
  [0, 0],
  [0, SIZE - 7],
  [SIZE - 7, 0],
];

/** 1 = dark finder module, 0 = quiet zone around it, null = data area. */
const finderCell = (r: number, c: number): 0 | 1 | null => {
  for (const [r0, c0] of FINDERS) {
    const y = r - r0;
    const x = c - c0;
    if (y >= 0 && y < 7 && x >= 0 && x < 7) return y === 0 || y === 6 || x === 0 || x === 6 || (y >= 2 && y <= 4 && x >= 2 && x <= 4) ? 1 : 0;
    if (y >= -1 && y <= 7 && x >= -1 && x <= 7) return 0;
  }
  return null;
};

/** FNV-1a, so the same member code always draws the same pattern. */
const hash = (text: string): number => {
  let h = 2166136261;
  for (let i = 0; i < text.length; i += 1) h = Math.imul(h ^ text.charCodeAt(i), 16777619);
  return h >>> 0;
};

/**
 * Decorative QR-like pattern seeded from the member code, as in the design.
 * It is not scannable: a real encoder needs a QR library (not a dependency yet),
 * so the code is printed underneath for staff to type in.
 */
export const MemberQr = ({ code, size = 126 }: { code: string; size?: number }) => {
  const cells = useMemo(() => {
    let state = hash(code) || 1;
    const next = () => {
      state ^= state << 13;
      state ^= state >>> 17;
      state ^= state << 5;
      return (state >>> 0) / 4294967296;
    };
    const on: [number, number][] = [];
    for (let r = 0; r < SIZE; r += 1) {
      for (let c = 0; c < SIZE; c += 1) {
        const finder = finderCell(r, c);
        if (finder === null ? next() < 0.45 : finder === 1) on.push([r, c]);
      }
    }
    return on;
  }, [code]);

  const svg = createElement(
    'svg',
    { viewBox: `0 0 ${SIZE} ${SIZE}`, width: size - 14, height: size - 14, 'aria-hidden': true, shapeRendering: 'crispEdges', style: { display: 'block' } },
    cells.map(([r, c]) => createElement('rect', { key: `${r}-${c}`, x: c, y: r, width: 1, height: 1, fill: colors.navy })),
  );
  return (
    <View
      role="img"
      aria-label={`Mã thành viên ${code}`}
      style={{ width: size, height: size, padding: 6, borderRadius: 12, borderWidth: 1, borderColor: colors.border, alignItems: 'center', justifyContent: 'center' }}
    >
      {svg}
    </View>
  );
};
